import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';

import { Container, useMediaQuery, Button, Toolbar, Typography, Grid, Box, Radio, FormControlLabel, RadioGroup, FormLabel, FormControl, TableContainer, Paper, TableCell, TableRow, TableBody, TableHead, Table, Alert, TablePagination, Pagination, ListItemText, ListItem, List } from "@mui/material"
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import addFundStyles from './AddFunds.module.css';
import withdrawnFundStyles from './RecentWithdrawalsList.module.css';
import { capitalise } from '../../utilities/capitalise';
import MyLodder from "../lodder";

import ApiClient from '../../utilities/apiClient';
import AppConfig from '../../AppConfig';

import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";



const FundTransferStatus = () => {
    const navigate = useNavigate();

    const apiToken = useSelector(state => state.auth.apiToken);
    const userId = useSelector(state => state.auth.userId);


    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const screen900px = useMediaQuery("(max-width : 900px)")
    const screen640px = useMediaQuery("(max-width : 640px)")


    const [showlodder, setShowLodder] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    const [paymentMode, setPaymentMode] = useState('payin');
    const [page, setPage] = useState(0);
    const [mpage, setMPage] = useState(1);
    const [mdata, setMdata] = useState([])
    const [mWData, setmWData] = useState([])

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paymentList, setPaymentList] = useState([])
    const [withdrawList, setWithdrawList] = useState([])
    dayjs.extend(utc);
    dayjs.extend(timezone);

    const columns = [
        { id: 'transactionDate', label: 'Date' },
        { id: 'orderId', label: 'Order ID' },
        { id: 'bankRefNo', label: 'Bank Ref No' },
        { id: 'bankAccountNo', label: "Account No" },
        { id: 'amount', label: 'Amount' },
        { id: 'paymentMode', label: 'Mode' },
        { id: 'orderStatus', label: 'Status' },
    ];

    const withdrawColumns = [
        { id: 'Punch_timetoview', label: 'Date' },
        { id: 'UserRefNo', label: 'UserRefNo' },
        { id: 'Bank_Acno', label: 'Account Number' },
        { id: 'AMOUNT', label: 'Requested Amount' },
        { id: 'AUTH_DUE_AMT', label: 'Processed Amount' },
        { id: 'Status', label: 'Status' },
    ];

    const customScrollbarStyles = {
        background: "#000000",
        width: "100%",
        scrollbarWidth: "thin",
        scrollbarColor: 'rgba(170,170,170,0.4) transparent',
    };

    const convertUTCToIST = (utcString) => {
     return dayjs.utc(utcString).tz("Asia/Kolkata").format("DD/MM/YYYY HH:mm:ss");
    };


    const getStatus = (status) => {

        return AppConfig.withdrawStatus[status] || "Unknown";
    };

    useEffect(() => {
        fetchUserInfo()

        if (paymentMode === "payin") {
            fetchPaymentList()
        }
        else {
            fetchWithdrawList()
        }
    }, [paymentMode])

    useEffect(() => {
        const newArr = paymentList && paymentList.slice((mpage - 1) * 5, (mpage) * 5)
        setMdata(newArr)
    }, [mpage, paymentList])

    useEffect(() => {
        const newArr = withdrawList && withdrawList.slice((mpage - 1) * 5, (mpage) * 5)
        setmWData(newArr)
        console.log(newArr, "newArrnewArr")
    }, [mpage, withdrawList])

    const fetchUserInfo = async () => {
        try {
            setShowLodder(true)
            const apiClient = new ApiClient(apiToken);
            apiClient.fetchData(
                AppConfig.api.Client.info,
                "POST",
                {
                    "ClientCode": userId,
                })
                .then((response) => {
                    setShowLodder(false)
                    if (response && response.Success == "True" && response.hasOwnProperty("Success Description")) {
                        let responseData = response["Success Description"];
                        if (Array.isArray(responseData) && responseData.length > 0) {
                            setUserInfo(responseData[0]);
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        } catch (error) {
            console.error('Error fetching holding data:', error);
        }
    };

    const fetchPaymentList = async () => {
        try {
            setShowLodder(true)
            const apiClient = new ApiClient(apiToken);
            apiClient.fetchData(
                AppConfig.api.Payment.list,
                "POST",
                {
                    "Client_id": userId,
                })
                .then((response) => {
                    setShowLodder(false)

                    let responseData = response

                    if (Array.isArray(responseData) && responseData.length > 0) {
                        console.info(`Payment LIst ${responseData}`);
                        setPaymentList(responseData);
                    }

                })
                .catch((error) => {
                    console.log(error, "Error in Payment list API");
                });
        } catch (error) {
            console.error('Error fetching holding data:', error);
        }
    };

    const fetchWithdrawList = async () => {

        let tdate = dayjs(new Date()).format('DD/MM/YYYY')
        let tdate1 = dayjs(new Date()).format('YYYY-MM-DD')
        let fdate = dayjs(tdate1).subtract(3, 'month').format('DD/MM/YYYY')
        console.log(fdate)
        console.log(tdate)
        setShowLodder(true)
        try {
            const apiClient = new ApiClient(apiToken);
            apiClient.fetchData(
                AppConfig.api.Withdraw.list,
                "POST",
                {
                    "FROM_DATE": fdate,
                    "TO_DATE": tdate,

                    "CLIENT_ID": userInfo.CLIENT_ID ? userInfo.CLIENT_ID : localStorage.getItem("userid"),
                    "TRANS_TYPE": "AP",
                    "datayear": localStorage.getItem("year")
                })
                .then((response) => {

                    setShowLodder(false)


                    if (response && response.Success == "False" && response.hasOwnProperty("Error Description")) {
                        setWithdrawList([]);
                    }
                    if (response && response.Success == "True" && response.hasOwnProperty("Success Description")) {
                        let responseData = response["Success Description"];

                        if (Array.isArray(responseData) && responseData.length > 0) {
                            setWithdrawList(responseData);
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        } catch (error) {
            console.error('Error fetching holding data:', error);
        }
    };

    const handlePaymentModeChange = (value) => {
        setPaymentMode(value.target.value);
    };

    const handlePageChange = (event, newpage) => {
        setPage(newpage);
    }

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    }

    const handleMPageChange = (event, newpage) => {
        setMPage(newpage);
    }

    return (
        <Container maxWidth="lg" sx={{ marginTop: !isSmallScreen && "10px", background: isSmallScreen && "#1B2636", minHeight: "100vh" }} >
            {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
            {isSmallScreen &&
                <Button onTouchStart={() => navigate("/dashboard")} sx={{ color: "#F3D45E", backgroundColor: "transparent", marginLeft: "10px", fontSize: "20px" }} ><ArrowBackIosIcon fontSize='10px' />Back</Button>
            }

            <Toolbar>
                <Typography variant="h5" component="div" sx={{ flexGrow: 1, marginLeft: isSmallScreen ? "0px" : "-40px", display: "flex", justifyContent: "start" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="30" viewBox="0 0 24 24" fill="none">
                        <path d="M16 12H18V16H16V12Z" fill="white" />
                        <path d="M20 7V5C20 3.897 19.103 3 18 3H5C3.346 3 2 4.346 2 6V18C2 20.201 3.794 21 5 21H20C21.103 21 22 20.103 22 19V9C22 7.897 21.103 7 20 7ZM5 5H18V7H5C4.74252 6.98848 4.49941 6.87809 4.32128 6.69182C4.14315 6.50554 4.04373 6.25774 4.04373 6C4.04373 5.74226 4.14315 5.49446 4.32128 5.30818C4.49941 5.12191 4.74252 5.01152 5 5ZM20 19H5.012C4.55 18.988 4 18.805 4 18V8.815C4.314 8.928 4.647 9 5 9H20V19Z" fill="white" />
                    </svg>
                    &nbsp;&nbsp;Fund Transfer Status
                </Typography>
                {!isSmallScreen &&
                    <Button onClick={() => navigate("/dashboard")} variant='text' sx={{
                        color: "#F3D45E", backgroundColor: "transparent", marginRight: "-30px", '&:hover': {
                            backgroundColor: 'transparent',
                        }
                    }}  ><ArrowBackIosIcon fontSize='10px' />Back</Button>}
            </Toolbar>

            {isSmallScreen ? (
                <>
                    {paymentMode === "payin" ? (
                        <>
                            <Grid container spacing={2} justifyContent={"center"}>
                                <Grid xs>
                                    <Box  sx={{ margin: '6% 0 0 9%' }}>
                                        <Typography variant="h4" component="h5" sx={{ marginBottom: "10px", lineHeight: "1.2 !important" }}>
                                            {userInfo && capitalise(userInfo.CLIENT_NAME)}
                                        </Typography>
                                        <Typography variant="h7">
                                            Client Code : {userInfo && userInfo.CLIENT_ID}
                                        </Typography>
                                    </Box>
                                </Grid>

                                <Grid container rowSpacing={1} xs={12} sx={{ margin: '6% 0 0 9%' }}>
                                    <Box sx={{ width: '100%' }}>
                                        <FormControl>
                                            <FormLabel sx={{ fontSize: "20px", color: "#FFFFFF" }}>Payment Mode</FormLabel>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                name="radio-buttons-group"
                                                value={paymentMode}
                                                onChange={handlePaymentModeChange}
                                                row
                                            >
                                                <FormControlLabel value="payin" control={<Radio />} label="Pay In" />
                                                <FormControlLabel value="payout" control={<Radio />} label="Pay Out" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Box>
                                </Grid>

                                {paymentList.length == 0 ? (
                                    <Grid style={{ display: 'flex', justifyContent: 'center' }}>
                                        <Alert severity="warning" style={{ background: 'transparent' }}>No Transactions found !</Alert>
                                    </Grid>
                                ) : (<List sx={{ width: "100%", margin: "20px 10px 0px 30px", background: "#0B1420", borderRadius: "10px" }}>
                                    {mdata.map((item, index) => {
                                        return (
                                            <ListItem className={addFundStyles.listItem} sx={{ display: "flex", flexDirection: "column", alignItems: "start", borderBottom: "1.5px solid #000000" }}>

                                                <ListItemText
                                                    sx={{ width: "100%" }}
                                                    primary={
                                                        <Box display="flex" >
                                                            <Grid width="35%" padding="0px">
                                                                <Typography className={addFundStyles.listPrimaryText}>Date</Typography>
                                                            </Grid>
                                                            <Grid width="35%" padding="0px">
                                                                <Typography className={addFundStyles.listPrimaryText} >Amount</Typography>
                                                            </Grid>
                                                            <Grid width="30%" padding="0px">
                                                                <Typography className={addFundStyles.listPrimaryText}>Mode</Typography>
                                                            </Grid>
                                                        </Box>
                                                    }
                                                    secondary={
                                                        <Box display="flex">
                                                            <Grid width="35%" padding="0px">
                                                                <Typography marginRight="15px" className={addFundStyles.listSecondaryText}>
                                                                  {convertUTCToIST(item.transactionDate)}

                                                                </Typography>
                                                            </Grid>
                                                            <Grid width="35%" padding="0px" >
                                                                <Typography className={addFundStyles.listSecondaryText} >
                                                                    ₹ {item.amount}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid width="30%" padding="0px" >
                                                                <Typography className={addFundStyles.listSecondaryText}>{item.paymentMode}</Typography>
                                                            </Grid>
                                                        </Box>
                                                    }
                                                />
                                                <ListItemText
                                                    sx={{ width: "100%" }}
                                                    primary={
                                                        <Box display="flex" >
                                                            <Grid width="35%" padding="0px">
                                                                <Typography className={addFundStyles.listPrimaryText}>Account No.</Typography>
                                                            </Grid>
                                                            <Grid width="35%" padding="0px" >
                                                                <Typography className={addFundStyles.listPrimaryText} >Bank Ref No</Typography>
                                                            </Grid>
                                                            <Grid width="30%" padding="0px" >
                                                                <Typography className={addFundStyles.listPrimaryText}>Status</Typography>
                                                            </Grid>
                                                        </Box>
                                                    }
                                                    secondary={
                                                        <Box display="flex">
                                                            <Grid width="35%" padding="0px">
                                                                <Typography marginRight="15px" className={addFundStyles.listSecondaryText} >
                                                                    <span className={addFundStyles.x}>{"x".repeat(item.bankAccountNo.length - 4)}</span>{item.bankAccountNo.slice(-4)}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid width="35%" padding="0px" >
                                                                <Typography className={addFundStyles.listSecondaryText} sx={{ wordWrap: "break-word", width: "85%" }} >
                                                                    {item.bankRefNo}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid width="30%" padding="0px" >
                                                                {item.orderStatus === "1" ? (
                                                                    <div className={addFundStyles.succdiv}>
                                                                        <Typography className={addFundStyles.succ} >Success</Typography>
                                                                    </div>
                                                                ) : (
                                                                    <div className={addFundStyles.faildiv}>
                                                                        <Typography className={addFundStyles.fail} >Failed</Typography>
                                                                    </div>
                                                                )}
                                                            </Grid>
                                                        </Box>
                                                    }
                                                />
                                            </ListItem>
                                        )
                                    })}
                                    <Grid sx={{ display: "flex", justifyContent: "center", padding: "10px 0px 10px 0px" }}>
                                        <Pagination showFirstButton showLastButton count={Math.ceil(paymentList.length / 5)} size="small" page={mpage}
                                            onChange={handleMPageChange} />
                                    </Grid>
                                </List>)}
                            </Grid>
                        </>
                    ) : (
                        <>
                            <Grid container spacing={2} justifyContent={"center"}>

                                <Grid xs >
                                    <Box sx={{ margin: '6% 0 0 9%' }}>
                                        <Typography variant="h4" component="h5" sx={{ marginBottom: "10px", lineHeight: "1.2 !important" }}>
                                            {userInfo && capitalise(userInfo.CLIENT_NAME)}
                                        </Typography>
                                        <Typography variant="h7">
                                            Client Code : {userInfo && userInfo.CLIENT_ID}
                                        </Typography>
                                    </Box>
                                </Grid>

                                <Grid container rowSpacing={1} xs={12} sx={{ margin: '6% 0 0 9%' }}>
                                    <Box sx={{ width: '100%' }}>
                                        <FormControl>
                                            <FormLabel sx={{ fontSize: "20px", color: "#FFFFFF" }}>Payment Mode</FormLabel>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                name="radio-buttons-group"
                                                value={paymentMode}
                                                onChange={handlePaymentModeChange}
                                                row
                                            >
                                                <FormControlLabel value="payin" control={<Radio />} label="Pay In" />
                                                <FormControlLabel value="payout" control={<Radio />} label="Pay Out" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Box>
                                </Grid>

                                {withdrawList.length == 0 ? (
                                    <Grid style={{ display: 'flex', justifyContent: 'center', marginTop: "20px", width: "100%" }}>
                                        <Alert severity="warning" style={{ background: 'transparent' }}>No Transactions found !</Alert>
                                    </Grid>
                                ) : (
                                    <List sx={{ width: "100%", marginLeft: "20px", marginRight: "15px", marginTop: "15px", background: "#0B1420", borderRadius: "10px" }}>
                                        {mWData?.map((item, index) => {
                                            
                                            return (
                                                <ListItem className={withdrawnFundStyles.listItem} sx={{ display: "flex", flexDirection: "column", alignItems: "start", borderBottom: "2px solid #000000" }}>

                                                    <ListItemText
                                                        sx={{ width: "100%" }}
                                                        primary={
                                                            <Box display="flex" >
                                                                <Grid width="35%" padding="0px">
                                                                    <Typography className={withdrawnFundStyles.listPrimaryText}>Date</Typography>
                                                                </Grid>
                                                                <Grid width="35%" padding="0px">
                                                                    <Typography className={withdrawnFundStyles.listPrimaryText} >Ref No</Typography>
                                                                </Grid>
                                                                <Grid width="30%" padding="0px">
                                                                    <Typography className={withdrawnFundStyles.listPrimaryText}>Status</Typography>
                                                                </Grid>
                                                            </Box>
                                                        }
                                                        secondary={
                                                            <Box display="flex">
                                                                <Grid width="35%" padding="0px">
                                                                    <Typography marginRight="15px" className={withdrawnFundStyles.listSecondaryText}>{item.Punch_timetoview?.slice(0, 10).split("-").join("/")}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid width="35%" padding="0px" >
                                                                    <Typography className={withdrawnFundStyles.listSecondaryText}
                                                                        sx={{ wordWrap: "break-word", width: "85%" }}
                                                                    >
                                                                        {item.UserRefNo}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid width="30%" padding="0px" >
                                                                    {getStatus(item.Status) == "Pending" ? <Button
                                                                        variant="outlined"
                                                                        color="inherit"
                                                                        size="small"
                                                                        sx={{ marginBottom: "10px" }}
                                                                        className={withdrawnFundStyles.cancelButton}
                                                                        fullWidth
                                                                    >
                                                                        Cancel
                                                                    </Button> :
                                                                        <Typography
                                                                            className={getStatus(item.Status) == 'Processed' && withdrawnFundStyles.statusProcessed || getStatus(item.Status) == 'Cancelled' && withdrawnFundStyles.statusCancelled}
                                                                            sx={{
                                                                                color: '#FFFFFF',
                                                                                fontSize: '14px',
                                                                                fontWeight: '400',
                                                                                marginBottom: "10px"
                                                                            }}
                                                                        >{getStatus(item.Status).toUpperCase()}</Typography>}
                                                                </Grid>
                                                            </Box>
                                                        }
                                                    />
                                                    <ListItemText
                                                        sx={{ width: "100%" }}
                                                        primary={
                                                            <Box display="flex" >
                                                                <Grid width="35%" padding="0px">
                                                                    <Typography className={withdrawnFundStyles.listPrimaryText}>Account No.</Typography>
                                                                </Grid>
                                                                <Grid width="35%" padding="0px" >
                                                                    <Typography className={withdrawnFundStyles.listPrimaryText} >Requested</Typography>
                                                                </Grid>
                                                                <Grid width="30%" padding="0px" >
                                                                    <Typography className={withdrawnFundStyles.listPrimaryText}>Processed</Typography>
                                                                </Grid>
                                                            </Box>
                                                        }
                                                        secondary={
                                                            <Box display="flex">
                                                                <Grid width="35%" padding="0px">
                                                                    <Typography marginRight="15px" className={withdrawnFundStyles.listSecondaryText}>
                                                                        <span className={withdrawnFundStyles.x}>{"x".repeat(item.Bank_Acno.length - 4)}</span>{item.Bank_Acno.slice(-4)}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid width="35%" padding="0px" >
                                                                    <Typography className={withdrawnFundStyles.listSecondaryText}  >
                                                                        {item.AMOUNT}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid width="30%" padding="0px" >
                                                                    <Typography className={withdrawnFundStyles.listSecondaryText} >
                                                                        {item.AMOUNT}
                                                                    </Typography>
                                                                </Grid>
                                                            </Box>
                                                        }
                                                    />
                                                </ListItem>
                                            )
                                        })}
                                        <Grid sx={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                                            <Pagination showFirstButton showLastButton count={Math.ceil(withdrawList.length / 5)} size="small" page={mpage}
                                                onChange={handleMPageChange} />
                                        </Grid>
                                    </List>
                                )}
                            </Grid>

                        </>
                    )}

                </>
            ) : (
                <>
                    <Grid container spacing={2} minHeight={160}>
                        <Grid xs={screen900px ? 6 : 3} sx={{ paddingLeft: "0px", marginTop: '1.5%' }} display="flex" justifyContent="left" alignItems="start" >
                            <Box sx={{ width: '100%' }}>
                                <Typography sx={{ fontSize: "20px", marginBottom: "12px" }}>
                                    {userInfo && capitalise(userInfo.CLIENT_NAME)}
                                </Typography>
                                <Typography variant="h7">
                                    Client Code : {userInfo && userInfo.CLIENT_ID}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid xs={screen900px ? 6 : 4} display="flex" justifyContent="center" alignItems="start" sx={{ marginTop: '1.5%' }} >
                            <Box sx={{ width: '100%', marginLeft: "10px" }}>
                                <FormControl>
                                    <FormLabel sx={{
                                        fontSize: "20px",
                                        color: "#FFFFFF"
                                    }} >Payment Mode</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        value={paymentMode}
                                        name="radio-buttons-group"
                                        onChange={handlePaymentModeChange}
                                        row
                                    >
                                        <FormControlLabel value="payin" control={<Radio />} label="Pay In" />
                                        <FormControlLabel value="payout" sx={{ marginLeft: screen640px ? "-11px" : "0px" }} control={<Radio />} label="Pay Out" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                        </Grid>

                        <Typography variant="h5" sx={{ marginTop: "30px", visibility: "hidden" }} gutterBottom>
                            Recent Transactions
                        </Typography>

                        <Typography variant="h5" sx={{ marginTop: "30px" }} gutterBottom>
                            Recent Transactions
                        </Typography>

                        {paymentMode === "payin" ? (
                            <>
                                <TableContainer component={Paper} className={addFundStyles.tablecontainer} sx={customScrollbarStyles} >
                                    {paymentList == 0 ? (<Table>
                                        <TableRow style={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
                                            <Alert severity="warning" style={{ background: 'transparent' }}>No Transactions found !</Alert>
                                        </TableRow>
                                    </Table>) :
                                        (<Table sx={{ width: "100%", background: "#0B1420", marginTop: "20px", borderRadius: "10px" }}>
                                            <TableHead>
                                                <TableRow>
                                                    {columns.map((column) => (
                                                        <TableCell className={addFundStyles.tablecellheader} sx={{ borderBottom: "2px solid #000000" }} key={column.id}>{column.label}</TableCell>
                                                    ))}
                                                    <TableCell className={addFundStyles.tablecellheader} style={{ display: 'none' }}>Actions</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {paymentList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                                    <TableRow key={index}>
                                                        {columns.map((column) => (
                                                            <TableCell
                                                                sx={{ borderBottom: "2px solid #000000" }}
                                                                className={`${addFundStyles.tablecell} ${column.id === 'Status' && addFundStyles.tablecelllow}`}
                                                                key={column.id}
                                                            >
                                                                {column.id === 'orderStatus' ?
                                                                    row[column.id] === '1' ?
                                                                        <div className={addFundStyles.succdiv}>
                                                                            <Typography className={addFundStyles.succ}>
                                                                                Successful
                                                                            </Typography>
                                                                        </div>
                                                                        :
                                                                        <div className={addFundStyles.faildiv}>
                                                                            <Typography className={addFundStyles.fail}>
                                                                                Failed
                                                                            </Typography>
                                                                        </div>
                                                                    :

                                                                    (
                                                                        column.id === 'amount' ?
                                                                            <Typography className={addFundStyles.tabletxt}>
                                                                                ₹  {row[column.id]}
                                                                            </Typography>

                                                                            :
                                                                            <Typography className={addFundStyles.tabletxt}>
                                                                                {column.id === "transactionDate" ?
                                                                                    (typeof row[column.id] === "string" ?   convertUTCToIST(column.transactionDate) : null)
                                                                                    : row[column.id]}
                                                                            </Typography>

                                                                    )}

                                                            </TableCell>
                                                        ))}

                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>)}


                                    {paymentList.length > 0 && <TablePagination
                                        sx={{ background: "#0B1420", width: "100%" }}
                                        rowsPerPageOptions={[10, 20, 50]}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        count={paymentList.length}
                                        component="div"
                                        onPageChange={handlePageChange}
                                        onRowsPerPageChange={handleRowsPerPageChange}
                                    />}
                                </TableContainer>
                            </>
                        ) : (
                            <>
                                <TableContainer component={Paper} className={withdrawnFundStyles.tablecontainer} >
                                    {withdrawList.length == 0 ? (
                                        <Table>
                                            <TableRow style={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
                                                <Alert severity="warning" style={{ background: 'transparent' }}>No Transactions found !</Alert>
                                            </TableRow>
                                        </Table>
                                    ) : (
                                        <Table sx={{ background: "#0B1420", marginTop: "20px", borderRadius: "10px" }}>
                                            <TableHead >
                                                <TableRow>
                                                    {withdrawColumns.map((column) => (
                                                        <TableCell className={withdrawnFundStyles.tablecellheader} key={column.id}>{column.label}</TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {withdrawList.length !== 0 &&
                                                    withdrawList
                                                        .sort((a, b) => {
                                                            // Assuming DATE1234 is a string in format '/DD/MM/YYYY'
                                                            const dateA = new Date(
                                                                `${a.DATE1234.substr(6, 4)}-${a.DATE1234.substr(3, 2)}-${a.DATE1234.substr(0, 2)}`
                                                            );
                                                            const dateB = new Date(
                                                                `${b.DATE1234.substr(6, 4)}-${b.DATE1234.substr(3, 2)}-${b.DATE1234.substr(0, 2)}`
                                                            );
                                                            return dateB - dateA; // Sort in descending order (latest to oldest)
                                                        })
                                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                                            <TableRow key={index}>
                                                                {withdrawColumns.map((column) => (
                                                                    <TableCell
                                                                        className={`${withdrawnFundStyles.tablecell} ${column.id === 'Status' && withdrawnFundStyles.tablecelllow}`}
                                                                        key={column.id}
                                                                    >
                                                                        {column.id === 'Status' ?
                                                                            <Typography className={getStatus(row.Status) == 'Pending' && withdrawnFundStyles.statusPending || getStatus(row.Status) == 'Processed' && withdrawnFundStyles.statusProcessed || getStatus(row.Status) == 'Cancelled' && withdrawnFundStyles.statusCancelled} >
                                                                                {getStatus(row.Status).toUpperCase() == "PENDING" ? "PROCESSING" : getStatus(row.Status).toUpperCase()}
                                                                            </Typography> :
                                                                            <Typography sx={{ fontSize: "12px" }}>
                                                                                {column.id == "Punch_timetoview" ? row[column.id].slice(0, 10).split("-").join("/") : row[column.id]}
                                                                            </Typography>}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        ))}
                                            </TableBody>
                                        </Table>
                                    )}

                                    {withdrawList.length > 0 && <TablePagination
                                        sx={{ background: "#0B1420" }}
                                        rowsPerPageOptions={[1, 10, 20, 50]}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        count={withdrawList.length}
                                        component="div"
                                        onPageChange={handlePageChange}
                                        onRowsPerPageChange={handleRowsPerPageChange}
                                    />}
                                </TableContainer>
                            </>
                        )}
                    </Grid>
                </>
            )}


            <MyLodder canShow={showlodder} />

        </Container>
    )
}

export default FundTransferStatus